module.exports = __webpack_public_path__ + "static/media/IconApp.9004075e.png";